import '.a{display:flex;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cx{background:var(--shades-white);}.ssr-plugin'
import '.cf{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b4{max-width:77.5rem;}.ssr-plugin'
import '.ds{justify-content:stretch;}.ssr-plugin'
import '.dt{position:sticky;}.ssr-plugin'
import '.du{top:0px;}.ssr-plugin'
import '.dv{z-index:10;}.ssr-plugin'
import '.eg{padding-block:1rem;}.ssr-plugin'
import '.eh{height:3rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.dy{flex-wrap:wrap;}.ssr-plugin'
import '.ei{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bl{margin-top:2rem;}.ssr-plugin'
import '.gq{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ae q b cx"
      >
        <div className="cf a c q b"
        >
          <div className="b4 a b ds dt du dv"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="eg eh a a9 c dy"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ei a b ae bl gq b4"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
